import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../AuthContext";
import { Link } from "react-router-dom";
import MIcon from "../icons/MIcon";

const Admin = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      {/* Card */}
      <div className="relative flat-card rounded-xl w-full max-w-[600px] animate-float-in">
        <div className="relative p-8 sm:p-10">
          {/* Header */}
          <div className="flex justify-center mb-8">
            <div className="w-14 h-14 rounded-lg bg-brand dark:bg-brand flex items-center justify-center shadow-brand-glow">
              <MIcon name="layers" className="text-white !text-[28px]" />
            </div>
          </div>

          <div className="text-center mb-8">
            <h1 className="font-display text-2xl font-semibold text-on-surface-light dark:text-on-surface tracking-tight mb-1.5">
              {t("admin.dashboard")}
            </h1>
            <p className="text-sm text-on-surface-light-variant dark:text-on-surface-variant">
              {t("admin.welcomeBack")}{" "}
              <span className="text-brand dark:text-brand font-medium">
                {user?.user}
              </span>
            </p>
          </div>

          {/* Quick Links */}

          <div className="space-y-3">
            <Link
              to="/admin/organizations"
              className="group flex items-center gap-4 p-4 rounded-lg bg-surface-light-low dark:bg-surface-container-low border border-surface-light-highest dark:border-white/5 hover:bg-surface-light-container dark:hover:bg-surface-container hover:border-brand/30 dark:hover:border-brand/30 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
            >
              <div className="flex items-center gap-4 p-4 rounded-lg transition-colors">
                <div className="w-10 h-10 rounded-lg bg-brand/10 dark:bg-brand/15 flex items-center justify-center text-brand dark:text-brand">
                  <MIcon name="corporate_fare" />
                </div>
                <div>
                  <p className="text-sm font-medium text-on-surface-light dark:text-on-surface">
                    {t("nav.organizations")}
                  </p>
                  <p className="text-xs text-on-surface-light-variant dark:text-on-surface-variant">
                    {t("admin.organizationsDesc")}
                  </p>
                </div>
              </div>
            </Link>

            <Link
              to="/admin/allowed-users"
              className="group flex items-center gap-4 p-4 rounded-lg bg-surface-light-low dark:bg-surface-container-low border border-surface-light-highest dark:border-white/5 hover:bg-surface-light-container dark:hover:bg-surface-container hover:border-brand/30 dark:hover:border-brand/30 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
            >
              <div className="flex items-center gap-4 p-4 rounded-lg transition-colors">
                <div className="w-10 h-10 rounded-lg bg-brand/10 dark:bg-brand/15 flex items-center justify-center text-brand dark:text-brand">
                  <MIcon name="group_add" />
                </div>
                <div>
                  <p className="text-sm font-medium text-on-surface-light dark:text-on-surface">
                    {t("nav.allowedUsers")}
                  </p>
                  <p className="text-xs text-on-surface-light-variant dark:text-on-surface-variant">
                    {t("admin.allowedUsersDesc")}
                  </p>
                </div>
              </div>
            </Link>

            <Link
              to="/analytics"
              className="group flex items-center gap-4 p-4 rounded-lg bg-surface-light-low dark:bg-surface-container-low border border-surface-light-highest dark:border-white/5 hover:bg-surface-light-container dark:hover:bg-surface-container hover:border-brand/30 dark:hover:border-brand/30 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
            >
              <div className="flex items-center gap-4 p-4 rounded-lg transition-colors">
                <div className="w-10 h-10 rounded-lg bg-emerald-500/10 dark:bg-emerald-400/10 flex items-center justify-center text-emerald-600 dark:text-emerald-400">
                  <MIcon name="monitoring" />
                </div>
                <div>
                  <p className="text-sm font-medium text-on-surface-light dark:text-on-surface">
                    {t("admin.analytics")}
                  </p>
                  <p className="text-xs text-on-surface-light-variant dark:text-on-surface-variant">
                    {t("admin.analyticsDesc")}
                  </p>
                </div>
              </div>
            </Link>

            <Link
              to="/admin/settings"
              className="group flex items-center gap-4 p-4 rounded-lg bg-surface-light-low dark:bg-surface-container-low border border-surface-light-highest dark:border-white/5 hover:bg-surface-light-container dark:hover:bg-surface-container hover:border-brand/30 dark:hover:border-brand/30 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
            >
              <div className="flex items-center gap-4 p-4 rounded-lg transition-colors">
                <div className="w-10 h-10 rounded-lg bg-brand/10 dark:bg-brand/15 flex items-center justify-center text-brand dark:text-brand">
                  <MIcon name="settings" />
                </div>
                <div>
                  <p className="text-sm font-medium text-on-surface-light dark:text-on-surface">
                    {t("nav.settings")}
                  </p>
                  <p className="text-xs text-on-surface-light-variant dark:text-on-surface-variant">
                    {t("admin.settingsDesc")}
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
